/** Traverse through the Skeleton (aka Graph) structure
 * starting from this joint (aka node, point, vertex). */
function TraverseJoint(joint, checked = [], callback) {
    checked.push(joint);
    for (const bone of joint.bones) {
        for (const nextJoint of bone.joints) {
            if (checked.includes(nextJoint))
                continue;
            TraverseJoint(nextJoint, checked, callback);
        }
    }
    return callback(joint);
}

export { TraverseJoint };
//# sourceMappingURL=traverse-joint.js.map
